module.exports = __webpack_public_path__ + "img/mp.451bfdba.svg";